// Modules
import React, { Fragment, ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';

// Styled Components
import * as EVENT from './event-content.styles';

// Types
import { Event } from '../../types/events';

import EventContentRightCol from '../event-content-right-col/event-content-right-col.component';
import EventContentLeftCol from '../event-content-left-col/event-content-left-col.component';

const EventContent = ({ event }: { event: Event }): ReactElement => {

	// Dispatcher
	const dir = useSelector((state: any) => state.common.dir);
	const lang = useSelector((state: any) => state.common.lang);
	// Render
	return (
		<EVENT.Content>
			<EventContentLeftCol event={event} />
			<EventContentRightCol event={event} />
		</EVENT.Content>
	);
};

export default EventContent;
